import { Col, Row, Typography } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@hooks/useAuth";
import { OnBoarding } from "@components/index";
import styles from "../Auth.module.scss";
import { SignInWithAzureAD } from "./SignInWithAzureAD";
import { useEffect, useState } from "react";
import { post } from "~/Services";
import microsoft from "@assets/PNG/microsoft.png";
import CLMLogo from "@assets/SVG/clm-logo.jpg";

const { Title, Text } = Typography;

export const Login = () => {
  const navigate = useNavigate();
  const { isLoading } = useAuth();
  const { state }: any = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if ((state && state.sessionExpired) || (window.history.state && window.history.state.sessionExpired)) {
      setOpen(true);
    }
  }, [state]);
  const handleModal = () => {
    setOpen(false);
    window.history.replaceState({}, document.title);
  };

  const onLogin = async (data: any) => {
    post("userprofile/login", data).then((res: any) => {
      if (res.response.data) {
        localStorage.setItem("userEmail", data.emailAddress);
        navigate("/auth/verify-otp");
      }
    });
  };

  return (
    <OnBoarding>
      <div>
        <Row>
          <Col span={24}>
            <img
              style={{ width: "100%" }}
              src={CLMLogo}
              alt="microsoft"
            />
          </Col>
          <Col
            className={styles.textCenter}
            span={24}
            style={{ padding: `${styles.whitespace4} 0px`, color: styles.gray }}
          >
            {/*Effortlessly sign in with Microsoft for a secure and streamlined authentication experience*/}
          </Col>
        </Row>
      <SignInWithAzureAD />
      </div>
    </OnBoarding>
  );
};
